/**
 * @author Tommy Brière
 * @copyright (c) 2015 Groupe PVP
 * @fileoverview Add some functionnnality to createjs Container
 **/
(function (createjs) {
    "use strict";
    var DisplayObject = createjs.DisplayObject;
    var Shape = createjs.Shape;
    var Container = createjs.Container;
    var Rectangle = createjs.Rectangle;
    var proto = DisplayObject.prototype;

    proto.setRectHitArea = function(bounds, y, w, h) {
        if (w) {
            bounds = new Rectangle(bounds, y, w, h);
        }
        var hit = new Shape();
        var g = hit.graphics;
        g.beginFill("red");
        g.drawRect(bounds.x, bounds.y, bounds.width, bounds.height);
        this.hitArea = hit; 
    };

    /**
     * Make sure that we scan each child of this container, wheater child are
     * in the children list or not
     * @param function f function to call on each item
     * @param boolean recursive description
     */
    proto.each = function (f, recursive) {
        var container = this;
        var childs = [this];
        if (recursive) {
            var oldF = f;
            f = function (it, i) {
                oldF(it, i);
                if (it instanceof Container) {
                    it.each(oldF, recursive);
                }
            };
        }

        var ignore = ["parent", "stage", "nextStage", "_prevStage", "_nextStage", "prevStage"];
        for (var i in container) {
            if (ignore.indexOf(i)===-1) {
                var it = container[i];
                if (it instanceof DisplayObject && it != container.parent) {
                    if (childs.indexOf(it) < 0) {
                        childs.push(it);
                        f(it, i);
                    }
                }
            }
        }
        for (var i = 0; i < container.numChildren; i++) {
            it = container.getChildAt(i);
            if (childs.indexOf(it) < 0) {
                childs.push(it);
                f(it);
            }
        }
    };

})(createjs);

